<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Filial"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
import FiliaisServicos from './FiliaisServicos'

export default {
    props: {
        filial: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Relação de Filial',
                html: `Confirma a exclusão da relação entre a matriz 
                    <strong>${this.filial.cnpjCpfMatriz}</strong> e a filial <strong>${this.filial.cnpjCpfFilial}</strong>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            FiliaisServicos.excluir(this.filial.filialId).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroExcluidoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroExcluidoComSucesso() {
            this.$toast.success(
                'Registro excluído com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterFiliais')
        }
    }
}
</script>
